<svg
  xmlns="http://www.w3.org/2000/svg"
  xmlns:xlink="http://www.w3.org/1999/xlink"
  preserveAspectRatio="xMinYMin"
  id="fillings-image"
  [attr.viewBox]="viewBoxString"
  class="cabinet-section-2d"
  (mousedown)="mouseDown($event)"
  (mousemove)="onDrag($event)"
  (mouseup)="mouseUp($event)"
>
  <g class="front-view">
    <!-- Spacing - Background -->
    <image
      width="1"
      height="1"
      preserveAspectRatio="none"
      attr.transform="scale({{ section.width }} {{ section.height - 21.5 }})"
      [attr.href]="section.profileMaterial.ImagePath"
    ></image>

    <ng-container *ngFor="let rail of sectionBottomDoorBackRails">
      <g
        class="rail"
        attr.transform="translate({{
          getRailXOffsetFromSectionBottomRail(rail)
        }} {{ section.height - getRailHeight(rail) }})"
      >
        <image
          width="1"
          height="1"
          preserveAspectRatio="none"
          attr.transform="scale({{ getBottomRailWidth(rail) }} {{
            getRailHeight(rail)
          }})"
          [attr.href]="section.profileMaterial.ImagePath"
        ></image>

        <path
          attr.d="{{
            getRailStrokePath(
              rail,
              getBottomRailWidth(rail),
              getRailHeight(rail)
            )
          }}"
          fill="none"
          stroke="grey"
          stroke-width="3"
        />
      </g>
    </ng-container>

    <!-- Modules + Module Frames -->
    <g
      *ngFor="let module of sortedModules"
      class="module"
      attr.transform="translate({{ module.posX }} 27)"
    >
      <!-- 27 = Spacing to ceiling -->

      <!-- Fillings -->
      <g
        *ngFor="let filling of module.fillings"
        class="filling"
        attr.transform="translate({{ fillingOffset }} {{ filling.posY }})"
        (click)="selectFilling($event, filling)"
        [class]="{ selected: isFillingSelected(filling) }"
      >
        <image
          *ngIf="!useCorrectlySizedMaterials(filling)"
          width="1"
          height="1"
          preserveAspectRatio="none"
          style="image-rendering: auto"
          attr.transform="{{ getFillingTransformString(filling, module) }}"
          [attr.href]="getFillingImagePath(filling)"
        />

        <g *ngIf="useCorrectlySizedMaterials(filling)">
          <defs>
            <pattern
              [id]="getFillingPatternId(module, filling)"
              *ngIf="filling.isDesignFilling &amp;&amp; filling.material"
              [attr.viewBox]="
                '0 0 ' +
                filling.material.TextureHeightMm +
                ' ' +
                filling.material.TextureWidthMm
              "
              [attr.width]="filling.material.TextureHeightMm"
              [attr.height]="filling.material.TextureWidthMm"
              patternUnits="userSpaceOnUse"
            >
              <image
                width="1"
                height="1"
                [attr.width]="filling.material.TextureWidthMm"
                [attr.height]="filling.material.TextureHeightMm"
                attr.transform="rotate( 270 ) translate( {{
                  -(filling?.material?.TextureWidthMm ?? 0)
                }} 0 )"
                preserveAspectRatio="none"
                style="image-rendering: auto"
                [attr.href]="getTextureUrl(filling.material)"
              />
            </pattern>
            <pattern
              [id]="getFillingPatternId(module, filling)"
              *ngIf="!filling.isDesignFilling &amp;&amp; filling.material"
              [attr.viewBox]="
                '0 0 ' +
                filling.material.TextureWidthMm +
                ' ' +
                filling.material.TextureHeightMm
              "
              [attr.width]="filling.material.TextureWidthMm"
              [attr.height]="filling.material.TextureHeightMm"
              patternUnits="userSpaceOnUse"
            >
              <image
                width="1"
                height="1"
                [attr.width]="filling.material.TextureWidthMm"
                [attr.height]="filling.material.TextureHeightMm"
                preserveAspectRatio="none"
                style="image-rendering: auto"
                [attr.href]="getTextureUrl(filling.material)"
              />
            </pattern>
          </defs>
          <rect
            [attr.fill]="'url(#' + getFillingPatternId(module, filling) + ')'"
            width="1"
            height="1"
            [attr.width]="filling.width"
            [attr.height]="filling.height"
            stroke-width="0"
          />
        </g>

        <rect
          class="select-marker"
          width="0"
          height="0"
          [attr.width]="filling.width"
          [attr.height]="filling.height"
          style="opacity: 0"
        ></rect>
      </g>

      <!-- Vertical Bars -->
      <g
        *ngFor="let position of verticalBarsPositions(module.id)"
        class="bar"
        attr.transform="translate({{ position }} 0)"
      >
        <image
          width="1"
          height="1"
          preserveAspectRatio="none"
          attr.transform="scale({{ section.barHeight }} {{ module.height }})"
          [attr.href]="section.profileMaterial.ImagePath"
        ></image>

        <rect
          class="outline"
          style="fill: none; stroke: grey; stroke-width: 2px"
          width="0"
          height="0"
          [attr.width]="section.barHeight"
          [attr.height]="module.height"
        ></rect>
      </g>

      <!-- Bars -->
      <g
        *ngFor="let bar of module.bars"
        class="bar"
        attr.transform="translate({{ getTopBottomFrameOffset(module) }} {{
          bar.position - bar.height / 2
        }}) {{ barDragOffsetTranslate(bar) }}"
        [class]="{ selected: isBarSelected(bar) }"
        (mousedown)="startDrag($event, bar)"
      >
        <image
          width="1"
          height="1"
          preserveAspectRatio="none"
          attr.transform="scale({{ bar.width }} {{ bar.height }})"
          [attr.href]="section.profileMaterial.ImagePath"
        ></image>

        <rect
          class="outline"
          style="fill: none; stroke: grey; stroke-width: 2px"
          width="0"
          height="0"
          [attr.width]="bar.width"
          [attr.height]="bar.height"
        ></rect>

        <rect
          class="select-marker"
          style="opacity: 0"
          width="0"
          height="0"
          [attr.width]="bar.width"
          [attr.height]="bar.height"
        ></rect>

        <foreignObject
          width="600"
          height="95"
          y="-20"
          style="pointer-events: none"
          [attr.width]="bar.width"
          *ngIf="showRulers"
        >
          <div
            xmlns="http://www.w3.org/1999/xhtml"
            style="text-align: center; width: 100%"
          >
            <span
              style="
                background-color: rgba(255, 255, 255, 0.5);
                font-size: 45px;
                text-align: center;
                margin: auto;
                padding: 6px 12px;
              "
              [textContent]="(module.height - bar.position).toFixed(0)"
            ></span>
          </div>
        </foreignObject>
      </g>

      <!-- Material Labels -->
      <ng-container *ngFor="let filling of module.fillings">
        <g
          class="material-label"
          *ngIf="showRulers"
          attr.transform="translate({{ fillingOffset }} {{ filling.posY }})"
        >
          <rect
            class="material-label-background"
            style="fill: rgba(255, 255, 255, 0.5)"
            width="0"
            height="95"
            [attr.width]="getLabelWidth(filling)"
            [attr.x]="(filling.width - getLabelWidth(filling)) / 2"
            [attr.y]="filling.height - 130"
          ></rect>

          <text
            class="material-label-text"
            style="font-size: 45px; pointer-events: none"
            [attr.x]="filling.width / 2"
            [attr.y]="filling.height - 65"
            text-anchor="middle"
          >
            {{ filling.material.Number }} - {{ filling.material.DefaultName }}
          </text>
        </g>
      </ng-container>

      <!-- Top Frame -->
      <!-- 21.5 is gotten from profile prod drawings -->
      <g
        class="frame"
        attr.transform="translate({{ getTopBottomFrameOffset(module) }} 0)"
      >
        <image
          width="1"
          height="1"
          preserveAspectRatio="none"
          attr.transform="scale({{ getTopBottomFrameWidth(module) }} 21.5)"
          [attr.href]="section.profileMaterial.ImagePath"
        ></image>
        <rect
          [attr.width]="getTopBottomFrameWidth(module)"
          height="21.5"
          fill="none"
          stroke="grey"
          stroke-width="3"
        />
      </g>

      <!-- Bottom Frame -->
      <!-- 21.5 is gotten from profile prod drawings -->
      <g
        class="frame"
        *ngIf="!isFrontDoor(module)"
        attr.transform="translate({{ getTopBottomFrameOffset(module) }} {{
          module.height - getBottomFrameHeight(module)
        }})"
      >
        <image
          width="1"
          height="1"
          preserveAspectRatio="none"
          attr.transform="scale({{ getTopBottomFrameWidth(module) }} {{
            getBottomFrameHeight(module)
          }})"
          [attr.href]="section.profileMaterial.ImagePath"
        ></image>
        <rect
          [attr.width]="getTopBottomFrameWidth(module)"
          [attr.height]="getBottomFrameHeight(module)"
          fill="none"
          stroke="grey"
          stroke-width="3"
        />
      </g>

      <!-- Left Frame -->
      <g class="frame" *ngIf="!isFrontDoor(module)">
        <image
          width="1"
          height="1"
          preserveAspectRatio="none"
          attr.transform="scale({{ getLeftFrameWidth(module) }} {{
            module.height
          }})"
          [attr.href]="section.profileMaterial.ImagePath"
        ></image>
        <rect
          [attr.width]="getLeftFrameWidth(module)"
          [attr.height]="module.height"
          fill="none"
          stroke="grey"
          stroke-width="3"
        />
      </g>

      <!-- Right Frame -->
      <g
        class="frame"
        *ngIf="!isFrontDoor(module)"
        attr.transform="translate({{
          module.width - getRightFrameWidth(module)
        }} 0)"
      >
        <image
          width="1"
          height="1"
          preserveAspectRatio="none"
          attr.transform="scale({{ getRightFrameWidth(module) }} {{
            module.height
          }})"
          [attr.href]="section.profileMaterial.ImagePath"
        ></image>
        <rect
          [attr.width]="getRightFrameWidth(module)"
          [attr.height]="module.height"
          fill="none"
          stroke="grey"
          stroke-width="3"
        />
      </g>
    </g>

    <!-- Profiles -->
    <g class="profiles">
      <ng-container *ngFor="let profile of sectionProfiles">
        <g
          attr.transform="translate({{ getProfileX(profile) }} 3)"
          *ngIf="shouldShowProfile(profile)"
        >
          <image
            width="1"
            height="1"
            preserveAspectRatio="none"
            attr.transform="scale({{ getProfileSize(profile) }} {{
              profile.height
            }})"
            [attr.href]="section.profileMaterial.ImagePath"
          ></image>

          <rect
            [attr.width]="getProfileSize(profile)"
            [attr.height]="profile.height"
            fill="none"
            stroke="grey"
            stroke-width="3"
          />
          <g class="item-ruler" *ngIf="showRulers">
            <rect
              class="item-ruler-background"
              width="0"
              style="fill: rgba(255, 255, 255, 0.5)"
              height="0"
              [attr.width]="80"
              [attr.height]="70"
              [attr.x]="(17 - 80) / 2"
              [attr.y]="section.height / 2 - 52"
            ></rect>
            <text
              class="item-ruler-text"
              [attr.x]="10"
              [attr.y]="section.height / 2"
              style="font-size: 40px; pointer-events: none"
              text-anchor="middle"
            >
              {{ profile.positionNo }}
            </text>
          </g>
        </g>
      </ng-container>
    </g>

    <!-- Rails -->
    <!-- Bottom Rail -->
    <ng-container *ngFor="let rail of sectionBottomRails">
      <g
        class="rail"
        attr.transform="translate({{
          getRailXOffsetFromSectionBottomRail(rail)
        }} {{ section.height - getRailHeight(rail) }})"
      >
        <image
          width="1"
          height="1"
          preserveAspectRatio="none"
          attr.transform="scale({{ getBottomRailWidth(rail) }} {{
            getRailHeight(rail)
          }})"
          [attr.href]="section.profileMaterial.ImagePath"
        ></image>

        <path
          attr.d="{{
            getRailStrokePath(
              rail,
              getBottomRailWidth(rail),
              getRailHeight(rail)
            )
          }}"
          fill="none"
          stroke="grey"
          stroke-width="3"
        />
      </g>

      <!-- Front Door Side Frames -->
      <!-- Needed to show frames in front of floor rails -->
      <ng-container *ngFor="let module of modules">
        <g
          *ngIf="isFrontDoor(module)"
          attr.transform="translate({{ module.posX }} 27)"
        >
          <!-- Bottom Frame -->
          <!-- 21.5 is gotten from profile prod drawings -->
          <g
            class="frame"
            attr.transform="translate({{ getTopBottomFrameOffset(module) }} {{
              module.height - getBottomFrameHeight(module)
            }})"
          >
            <image
              width="1"
              height="1"
              preserveAspectRatio="none"
              attr.transform="scale({{ getTopBottomFrameWidth(module) }} {{
                getBottomFrameHeight(module)
              }})"
              [attr.href]="section.profileMaterial.ImagePath"
            ></image>
            <rect
              [attr.width]="getTopBottomFrameWidth(module)"
              [attr.height]="getBottomFrameHeight(module)"
              fill="none"
              stroke="grey"
              stroke-width="3"
            />
          </g>

          <!-- Left Frame -->
          <g class="frame">
            <image
              width="1"
              height="1"
              preserveAspectRatio="none"
              attr.transform="scale({{ getLeftFrameWidth(module) }} {{
                module.height
              }})"
              [attr.href]="section.profileMaterial.ImagePath"
            ></image>
            <rect
              [attr.width]="getLeftFrameWidth(module)"
              [attr.height]="module.height"
              fill="none"
              stroke="grey"
              stroke-width="3"
            />
          </g>

          <!-- Right Frame -->
          <g
            class="frame"
            attr.transform="translate({{
              module.width - getRightFrameWidth(module)
            }} 0)"
          >
            <image
              width="1"
              height="1"
              preserveAspectRatio="none"
              attr.transform="scale({{ getRightFrameWidth(module) }} {{
                module.height
              }})"
              [attr.href]="section.profileMaterial.ImagePath"
            ></image>
            <rect
              [attr.width]="getRightFrameWidth(module)"
              [attr.height]="module.height"
              fill="none"
              stroke="grey"
              stroke-width="3"
            />
          </g>
        </g>
      </ng-container>
    </ng-container>

    <!-- Top Rail -->
    <ng-container *ngFor="let rail of sectionTopRails">
      <g
        class="rail"
        attr.transform="translate({{
          getRailXOffsetFromSectionTopRail(rail)
        }} {{ getRailYOffset(rail) }})"
      >
        <image
          width="1"
          height="1"
          preserveAspectRatio="none"
          attr.transform="scale({{ getTopRailWidth(rail) }} {{
            getRailHeight(rail)
          }})"
          [attr.href]="section.profileMaterial.ImagePath"
        ></image>

        <path
          attr.d="{{
            getRailStrokePath(rail, getTopRailWidth(rail), getRailHeight(rail))
          }}"
          fill="none"
          stroke="grey"
          stroke-width="3"
        />
      </g>
    </ng-container>

    <ng-container *ngFor="let rail of sectionRails">
      <g class="item-ruler" *ngIf="showRulers">
        <rect
          class="item-ruler-background"
          width="0"
          style="fill: rgba(255, 255, 255, 0.5)"
          height="0"
          [attr.width]="80"
          [attr.height]="70"
          [attr.transform]="getRailPositionRect(rail)"
        ></rect>
        <text
          class="item-ruler-text"
          style="font-size: 40px; pointer-events: none"
          [attr.transform]="getRailPositionNumber(rail)"
          text-anchor="middle"
        >
          {{ rail.positionNo }}
        </text>
      </g>
    </ng-container>
  </g>

  <g
    class="topdown-view"
    attr.transform="translate({{ topDownAreaPosX }} {{ topDownAreaPosY }})"
    *ngIf="showTopdown"
  >
    <ng-container *ngFor="let module of modules">
      <g
        class="door-topdown-group"
        attr.transform="translate({{ module.posX }} {{
          getTopDownModuleY(module)
        }})"
      >
        <rect
          class="door-topdown"
          x="0"
          y="0"
          width="0"
          height="0"
          style="fill: #111; stroke: #666; stroke-width: 3px"
          [attr.width]="module.width"
          [attr.height]="module.depth"
        ></rect>

        <text
          style="font-size: 40px"
          x="0"
          y="-10"
          [attr.x]="module.width / 2"
          text-anchor="middle"
        >
          {{ module.positionNo }} - {{ roundUp(module.width) }}
        </text>
      </g>
    </ng-container>
  </g>

  <!-- Outer Rulers -->
  <g class="ruler-view" *ngIf="showRulers" style="pointer-events: none">
    <g *ngFor="let ruler of rulers">
      <g
        class="ruler vertical-ruler"
        *ngIf="ruler.isVertical"
        attr.transform="translate( {{ ruler.svgStart.X }} {{
          ruler.svgStart.Y
        }} )"
      >
        <line
          class="ruler-line ruler-serif"
          style="stroke: black; stroke-width: 3px"
          [attr.x1]="-ruler.serifSize"
          [attr.x2]="ruler.serifSize"
          y1="0"
          y2="0"
        />
        <line
          class="ruler-line ruler-serif"
          style="stroke: black; stroke-width: 3px"
          [attr.x1]="-ruler.serifSize"
          [attr.x2]="ruler.serifSize"
          [attr.y1]="-ruler.length"
          [attr.y2]="-ruler.length"
        />
        <line
          class="ruler-line ruler-main-line"
          style="stroke: black; stroke-width: 3px"
          y1="0"
          [attr.y2]="-ruler.length"
          x1="0"
          x2="0"
        />
        <text
          class="ruler-text"
          style="font-size: 50px"
          x="-10px"
          [attr.y]="-ruler.length / 2"
          attr.transform="rotate( -90 0 {{ -ruler.length / 2 }} )"
          text-anchor="middle"
        >
          {{ ruler.length.toFixed(0) }}
        </text>
      </g>

      <g
        class="ruler horizontal-ruler"
        *ngIf="!ruler.isVertical"
        attr.transform="translate( {{ ruler.svgStart.X }} {{
          ruler.svgStart.Y
        }} )"
      >
        <line
          class="ruler-line ruler-serif"
          style="stroke: black; stroke-width: 3px"
          x1="0"
          x2="0"
          [attr.y1]="-ruler.serifSize"
          [attr.y2]="ruler.serifSize"
        />
        <line
          class="ruler-line ruler-serif"
          style="stroke: black; stroke-width: 3px"
          [attr.x1]="ruler.length"
          [attr.x2]="ruler.length"
          [attr.y1]="-ruler.serifSize"
          [attr.y2]="ruler.serifSize"
        />
        <line
          class="ruler-line ruler-main-line"
          style="stroke: black; stroke-width: 3px"
          x1="0"
          [attr.x2]="ruler.length"
          y1="0"
          y2="0"
        />
        <text
          class="ruler-text"
          style="font-size: 50px"
          y="-10px"
          [attr.x]="ruler.length / 2"
          text-anchor="middle"
        >
          {{ ruler.length.toFixed(0) }}
        </text>
      </g>
    </g>
  </g>
</svg>
